<template>
<div class="col-12 col-lg-6 c">
    <div class="card card-body">
        <div class="row">
            <div class="col-12 col-lg-6 g">
                <button :class="`btn btn-block ` + (method == 'students' ? 'btn-primary' : 'btn-outline-primary')" @click="method = 'students'">
                    <i class="fa fa-user"></i>
                    تحديد طلاب فردياً
                </button>
            </div>
            <div class="col-12 col-lg-6 g">
                <button :class="`btn btn-block ` + (method == 'classrooms' ? 'btn-primary' : 'btn-outline-primary')" @click="method = 'classrooms'">
                    <i class="fa fa-user"></i>
                    تحديد فصول
                </button>
            </div>
        </div>
    </div>
    <div class="card card-body" v-if="method == 'students'">
        <div class="g">
            <i class="fa fa-users"></i>
            اختر الطلاب <a href="javascript:;" @click="selected_students = students.map(function(x){return x.number})"><u><i class="fa fa-check-square"></i> اختيار الكل</u></a>
        </div>
        <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 250px;">
            <div class="form-check" v-for="student in students" :key="student._id">
            <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="selected_students" :value="student.number">
                {{ student.name }}
            </label>
            </div>
        </div>
    </div>
    <div class="card card-body" v-if="method == 'classrooms'">
        <div class="g">
            <i class="fa fa-users"></i>
            اختر الفصول
        </div>
        <div class="form-check" v-for="classroom in classrooms" :key="classroom">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" :value="classroom" v-model="selected_classrooms">
            <h5>
                {{ classroom.replace(',', " - ") }}
            </h5>
          </label>
        </div>
    </div>
    <div class="card card-body" v-if="method != ''">
        <strong style="padding-bottom: 10px"><i class="fa fa-check-square"></i> إختر الأجهزة المراد الحذف منها</strong>
        <div class="form-check" v-for="device in devices" :key="device._id">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model="selected_devices" :value="device.serial_number">
            <h5>
                {{ device.title }}
            </h5>
          </label>
        </div>
    </div>
    <div class="carsd card-body" style="padding: 0px" v-if="method != '' && selected_devices.length && (selected_students.length || selected_classrooms.length)">
        <div class="col-12 text-center g">
            <button class="btn btn-danger" @click="done()">
                <i class="fa fa-check"></i>
                حذف الطلاب الآن
            </button>
        </div>
    </div>
    <a href="/devices/add-admins" class="text-muted">add admin</a>
</div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { VBModal, BModal, BFormInput } from "bootstrap-vue";
export default {
  components: {
    // Layouts
    BModal,BFormInput},
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            method: "", // students or classrooms
            devices: [],
            user: JSON.parse(localStorage.getItem('user')),
            type: 'students',
            serial_number: '',
            title: "",
            selected_classrooms: [],
            current: {},
            pending: 0,
            students: [],
            classrooms: [],
            objloading: {},
            teachers: [],
            selected_students: [],
            selected_devices: [],
            from: new Date().toISOString().split("T")[0],
            to: new Date().toISOString().split("T")[0],
            interval: null,
            logs: []
        }
    },
    created(){
        if(!checkPer("devices")){
            this.$router.push('/NotPermitted')
            return false;
        }
        this.getDevices();
        var g = this;
        $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            q: "",
            page: 1,
            perpage: 9999
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.students = r.response;
                g.students.forEach(function(a){
                    if(!g.classrooms.includes(a.classname + ',' + a.classroom)){
                        g.classrooms.push(a.classname + ',' + a.classroom)
                    }
                })
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    beforeDestroy(){
        if(this.interval){
            clearInterval(this.interval)
        }
    },
    methods: {
        timeexnow(device){
            var date = new Date().toISOString().split("T")[0];
            if(new Date() >= new Date(date + ' ' + device?.ex_from)){
                if(new Date() <= new Date(date + ' ' + device?.ex_to)){
                    return true;
                }
            }
            return false;
        },
        getDevices(){
            var g = this;
            $.post(api + '/user/devices/all', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.devices = r.response.map(function(a){
                        return a;
                    })
                }
            }).fail(function(){
            })
        },
        done(){
            var g = this;
            if(g.method == 'students'){
                var students = JSON.parse(JSON.stringify(g.selected_students));
            }else{
                var students = [];
                g.selected_classrooms.forEach(function(a){
                    g.students.forEach(function(b){
                        if(b.classname + ',' + b.classroom == a){
                            students.push(b.number)
                        }
                    })
                })
            }
            $.post(api + '/user/devices/delete-users', {
                jwt: this.user.jwt,
                numbers: JSON.stringify(students),
                devices: JSON.stringify(g.selected_devices)
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    alert("تم ارسال الأمر بنجاح", 100)
                }
            }).fail(function(){
            })
        },
    }
}
</script>

<style>

</style>